<template>
    <div class="mt-5">
        <!-- Question -->
	    <div v-if="data.meta" class="d-flex flex-column gap-3 text-center mb-5">
		    <h3 v-if="questionDescription" class="fw-semi-bold m-0" v-html="questionDescription"></h3>
		    <p v-if="questionSubText" class="text-secondary m-0" v-html="questionSubText"></p>
	    </div>

        <!-- Input -->
        <div class="d-flex gap-3 justify-content-center" v-if="data.options">
            <div v-for="(option, index) in data.options" :key="index"
                class="d-flex flex-column gap-2 align-items-center justify-content-center rounded-15 option py-3 px-3 flex-grow-1 cursor-pointer ripple"
                @click="handleOptionClick(option)" v-ripple :class="selectedOption && selectedOption.length && selectedOption[0].id === option.id ? 'selected' : ''">

                <i class="fs-3 mb-2 bi" v-if="option.iconClass" :class="option.iconClass"></i>
	            <i class="fs-3 mb-2 bi" v-if="option.icon" :class="option.icon"></i>

                <p class="m-0 fw-medium" v-if="option.label">{{ option.label }}</p>
	            <p class="m-0 fw-medium" v-if="option.value && !props.hideValue">{{ option.value }}</p>

                <p class="fs-6 text-secondary" v-if="option.description">{{ option.description }}</p>
	            <p class="fs-6 text-secondary" v-if="option.text">{{ option.text }}</p>

            </div>
        </div>

        <!-- Error message -->
        <p v-if="showError && (selectedOption == null || selectedOption.length === 0) && !data.skippable" class="text-danger my-3">Please select an option</p>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
	questionDescription: String,
	questionSubText: String,
    data: Object,
	showError: {
		type: Boolean,
		default: true,
		require: false
	},
	hideValue: {
		type: Boolean,
		default: false,
		require: false
	},
	answer: {
		type: Array,
		default: () => []
	},
});

const selectedOption = ref(props.answer);

const emit = defineEmits(['question-answered']);
watch(selectedOption, (newVal) => {
    emit('question-answered', newVal != null ? selectedOption.value : null);
})

const handleOptionClick = (option) => {
    selectedOption.value = [option];
};
</script>

<style scoped lang="scss">
.rounded-15 {
    border-radius: 15px;
}



.option {
    min-height: 10em;
    border: 2px solid #d4d8dc;
    background-color: transparent;
    user-select: none;
    &:hover {
        background: #f5f5f7 !important;
    }

    &:not(.selected) {
        --bs-border-opacity: .5;
    }

    &.selected {
        border-color: #adb5bd !important;
        background: #8789871a !important;
    }

    &.has-error {
        border-color: #dc462f !important;
        background: #e94f3724 !important;

        &:hover {
            background: rgba(232, 40, 10, 0.14) !important;
        }
    }
}
</style>